"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateEmptyPortfolioReceivableResponseTape = exports.getPortfolioReceivableResponseTapeStatsOnly = exports.generateCollateralAssignmentTape = exports.generateLoanAccountTape = exports.getCollateralDescription = exports.getDedupedTotalMarketValue = exports.getTotalPostAllocationLendableValue = exports.getAdvanceRate = exports.getSecurityType = exports.getQuantity = exports.groupReceivableResponseTape = exports._createFinelyVBResponseTapeRow = exports._createTestBorrowingBaseReceivable = void 0;
const lodash_1 = __importDefault(require("lodash"));
const common_1 = require("@finley-technologies/common");
const consts_1 = require("../consts");
const typeguards_1 = require("../typeguards");
const utils = __importStar(require("../utils"));
const generateReceivableStats_1 = require("./generateReceivableStats");
const utils_1 = require("./utils");
// @jendevelops TODO: move to tests once temp no longer used
const _createTestBorrowingBaseReceivable = ({ exposure, advanceRate, lendableValue, }) => {
    return {
        loanProductId: 'loanProductId',
        finleyReceivableId: 'finleyReceivableId',
        externalReceivableId: 'externalReceivableId',
        baseFields: {
            baseField: 'baseField',
            pre_allocation_lendable_value: lendableValue,
            reporting_date: '2024-01-01',
            finley_receivable_id: 'aaa',
            finley_loan_product_id: 'aaa',
            finley_exposure: lendableValue,
            arrangement_group: 'aaa',
            cif_num: 'aaa',
            collateral_account_number: 'aaa',
            collateral_account_type: 'IBS',
            finley_valuation_rate: 1,
            product_name: 'aaa',
            finley_assigned_to_loan_accounts: null,
            loan_account_number: null,
            post_allocation_lendable_value: lendableValue,
        },
        dynamicIntermediateFields: {
            dynamicIntermediateField: 'dynamicIntermediateField',
        },
        requiredIntermediateFields: {
            assignmentExclusion: 'none',
            exposure,
            waiveAllEligibility: false,
            waiveAllConcentration: false,
            includeInConcentrationLimitDenominatorIfWaived: false,
            originalOwnerSlug: 'originalOwnerSlug',
            normalizedDurationDays: 100,
            normalizedisChargedOff: false,
            normalizedisDelinquent: false,
            normalizedDaysPastDue: 100,
            normalizedOriginationDate: 'normalizedOriginationDate',
            normalizedInitialBalance: 100,
        },
        postProcessedFields: {
            originalOwnerId: 'originalOwnerId',
            normalizedExposure: exposure,
            preassignmentCreditFacilityId: 'preassignmentCreditFacilityId',
            performingExposure: exposure,
        },
        assignmentFields: {
            assignedAt: 'assignedAt',
            creditFacilityId: 'creditFacilityId',
            reportingDate: '2023-03-06',
            fileVersion: 1,
            purchasePrice: exposure * advanceRate,
            purchasePercentageRate: advanceRate,
        },
        valuationFields: {
            valuation: 1,
            valuationRate: 1, // todo add in valuation rate
        },
        eligibilityStatuses: [
            {
                eligibilityCriteriaKey: 'eligibilityCriteriaKey',
                eligibilityStatus: 'ELIGIBLE',
            },
        ],
        eligibilityFields: {
            eligibleExposure: exposure,
            isEligible: true,
            eligibilityKickout: 0,
        },
        concentrationLimitReasons: [],
        concentrationLimitWaivers: [],
        concentrationLimitFields: {
            eligibleExposureLessConcentrationLimitKickouts: exposure,
        },
        borrowingBaseFields: {
            borrowingBaseAmount: exposure * advanceRate,
            advanceRate,
            advanceRatePath: 'advanceRatePath',
        },
    };
};
exports._createTestBorrowingBaseReceivable = _createTestBorrowingBaseReceivable;
// @jendevelops TODO: move to tests once temp no longer used
const _createFinelyVBResponseTapeRow = ({ reportingDate, loanAccountNumber, arrangementGroup, cifNum, collateralAccountNumber, loanProductId, creditAgreementId, finleyReceivableId, }) => {
    return {
        reportingDate,
        isPreview: utils.isValleyBankPreview(creditAgreementId),
        finley_receivable_id: finleyReceivableId,
        creditAgreementId,
        finley_loan_product_id: loanProductId,
        loan_account_number: loanAccountNumber,
        arrangement_group: arrangementGroup,
        cif_num: cifNum,
        collateral_account_number: collateralAccountNumber,
    };
};
exports._createFinelyVBResponseTapeRow = _createFinelyVBResponseTapeRow;
const groupReceivableResponseTape = ({ receivables, groupBy, }) => {
    const groupedReceivables = {};
    receivables.reduce((grouped, receivable) => {
        const key = receivable[groupBy];
        if (key === null) {
            return grouped;
        }
        if (!grouped[key]) {
            // eslint-disable-next-line no-param-reassign
            grouped[key] = [];
        }
        grouped[key].push(receivable);
        return grouped;
    }, groupedReceivables);
    return groupedReceivables;
};
exports.groupReceivableResponseTape = groupReceivableResponseTape;
/**
 * @jendevelops TODO: getEffectiveAllocation
 */
const getQuantity = (receivable) => {
    var _a;
    const value = (_a = receivable.receivableReponseTapeRow.baseFields.he_secd_pldg_unit) !== null && _a !== void 0 ? _a : receivable.receivableReponseTapeRow.baseFields.he_secd_unpldg_unit;
    return value ? Number(value) : null;
};
exports.getQuantity = getQuantity;
const getSecurityType = (receivable) => {
    var _a;
    return String((_a = receivable.receivableReponseTapeRow.baseFields.he_sec_asset_class) !== null && _a !== void 0 ? _a : '-');
};
exports.getSecurityType = getSecurityType;
const getAdvanceRate = (receivable) => receivable.receivableReponseTapeRow.borrowingBaseFields.advanceRate;
exports.getAdvanceRate = getAdvanceRate;
const getTotalPostAllocationLendableValue = (receivables) => receivables.reduce((acc, receivable) => acc + (0, utils_1.getPostAllocationLendableValue)(receivable), 0);
exports.getTotalPostAllocationLendableValue = getTotalPostAllocationLendableValue;
/**
 * Needs to take into account allocation so that we don't multiply the market value
 * by the number of receivables that show up per cross collateralized account
 */
const getDedupedTotalMarketValue = (receivables) => {
    const { totalPostAllocationLendableValue } = (0, generateReceivableStats_1.generateReceivableStats)(receivables);
    return totalPostAllocationLendableValue;
};
exports.getDedupedTotalMarketValue = getDedupedTotalMarketValue;
const getLoanAccountStats = (receivables) => {
    let totalMarketValue = 0;
    let totalPostAllocationLendableValue = 0;
    let preAllocationLendableValue = 0;
    receivables.forEach((rec) => {
        const marketValue = (0, utils_1.getPreAllocationMarketValue)(rec);
        const advanceRate = (0, exports.getAdvanceRate)(rec);
        const allocation = rec.receivableReponseTapeRow.valuationFields.valuationRate;
        const lendableValue = marketValue * advanceRate;
        const postAllocationLendableValue = lendableValue * allocation;
        totalMarketValue += marketValue;
        preAllocationLendableValue += lendableValue;
        totalPostAllocationLendableValue += postAllocationLendableValue;
    });
    const effectiveAllocationRate = common_1.utils.divideByOrZero(totalPostAllocationLendableValue, preAllocationLendableValue);
    const effectiveAdvanceRate = common_1.utils.divideByOrZero(preAllocationLendableValue, totalMarketValue);
    return {
        totalMarketValue,
        effectiveAllocationRate,
        totalPostAllocationLendableValue,
        effectiveAdvanceRate,
        preAllocationLendableValue,
    };
};
const getCollateralDescription = (receivable) => {
    // may need hecoll_desc_2
    const desc = receivable.receivableReponseTapeRow.baseFields.hecoll_desc ||
        receivable.receivableReponseTapeRow.baseFields.hecoll_desc_2 ||
        '-';
    return String(desc);
};
exports.getCollateralDescription = getCollateralDescription;
const generateLoanAccountTape = ({ receivables, loanBalances, }) => {
    const assignedReceivables = receivables.filter((rec) => rec.loan_account_number !== null);
    const groupByLoanAccount = (0, exports.groupReceivableResponseTape)({
        receivables: assignedReceivables,
        groupBy: 'loan_account_number',
    });
    const tape = Object.entries(groupByLoanAccount).map(([loanAccountNumber, groupedAssignedReceivables]) => {
        let loanAccountBalance = loanBalances.get(loanAccountNumber);
        if (typeof loanAccountBalance !== 'number') {
            loanAccountBalance = 0;
        }
        const { totalMarketValue, effectiveAllocationRate, totalPostAllocationLendableValue, effectiveAdvanceRate, preAllocationLendableValue, } = getLoanAccountStats(groupedAssignedReceivables);
        return {
            loanAccountNumber,
            loanAccountBalance,
            totalMarketValue,
            effectiveAdvanceRate,
            preAllocationLendableValue,
            effectiveAllocationRate,
            totalPostAllocationLendableValue,
        };
    });
    // for any loan accounts that have no receivables, we still want to include them in the tape
    const loanAccountNumbers = new Set(assignedReceivables.map((rec) => rec.loan_account_number));
    loanBalances.forEach((balance, loanAccountNumber) => {
        if (!loanAccountNumbers.has(loanAccountNumber)) {
            tape.push({
                loanAccountNumber,
                loanAccountBalance: balance,
                totalMarketValue: 0,
                effectiveAdvanceRate: 0,
                preAllocationLendableValue: 0,
                effectiveAllocationRate: 0,
                totalPostAllocationLendableValue: 0,
            });
        }
    });
    return tape;
};
exports.generateLoanAccountTape = generateLoanAccountTape;
const _getPortfolioCollateralAccountStats = (receivables) => {
    const collateralAccountStatWarnings = [];
    const collateralAccountStats = [];
    const allReceivablesGroupedbyCollateralAccountNumber = (0, exports.groupReceivableResponseTape)({ receivables, groupBy: 'collateral_account_number' });
    Object.entries(allReceivablesGroupedbyCollateralAccountNumber).forEach(([collateralAccountNumber, records]) => {
        const firstReceivable = records.length ? records[0] : null;
        if (firstReceivable) {
            (0, common_1.finleyAssert)((0, typeguards_1.hasValleyBankRequiredBaseFields)(firstReceivable.receivableReponseTapeRow.baseFields), `[collateralAccountNumber:${collateralAccountNumber}] [finleyReceivableId:${firstReceivable.finley_receivable_id}] is missing valley bank required baseFields.`);
            const collateralAccountType = firstReceivable.receivableReponseTapeRow.baseFields
                .collateral_account_type;
            const { totalMarketValue, totalPostAllocationLendableValue, totalPreAllocationLendableValue, effectiveAdvanceRate, effectiveAllocationRate, } = (0, generateReceivableStats_1.generateReceivableStats)(records);
            collateralAccountStats.push({
                collateralAccountNumber,
                collateralAccountType,
                totalMarketValue,
                totalPostAllocationLendableValue,
                totalPreAllocationLendableValue,
                effectiveAdvanceRate,
                effectiveAllocationRate,
            });
        }
        else {
            collateralAccountStatWarnings.push(`[collateralAccountNumber:${collateralAccountNumber}] did not contain any individual collateral records.  This collateral account number will not appear in the collateral account stats.`);
        }
    });
    return { collateralAccountStats, collateralAccountStatWarnings };
};
// stripping out any non-related pg columns
const generateCollateralAssignmentTape = (collateralToLoanAccountMappings) => collateralToLoanAccountMappings.map((row) => ({
    loanAccountNum: row.loanAccountNum,
    collateralAccountNum: row.collateralAccountNum,
    collateralAccountType: row.collateralAccountType,
    reportingDate: row.reportingDate,
}));
exports.generateCollateralAssignmentTape = generateCollateralAssignmentTape;
const getPortfolioReceivableResponseTapeStatsOnly = ({ receivables, loanBalances, }) => {
    const warnings = [];
    const { collateralAccountStats, collateralAccountStatWarnings, } = _getPortfolioCollateralAccountStats(receivables);
    collateralAccountStatWarnings.forEach((warning) => {
        warnings.push(warning);
    });
    const loanAccountStats = [];
    const unassignedReceivables = receivables.filter((rec) => rec.loan_account_number === null);
    const assignedReceivables = receivables.filter((rec) => rec.loan_account_number !== null);
    // unassigned stats
    const { totalMarketValue: unassignedTotalMarketValue, totalPostAllocationLendableValue: unassignedAllocatedTotalLendableValue, effectiveAdvanceRate: unassignedEffectiveAdvanceRate, } = (0, generateReceivableStats_1.generateReceivableStats)(unassignedReceivables);
    const unassignedCollateralAccountsSet = new Set();
    unassignedReceivables.forEach((rec) => {
        unassignedCollateralAccountsSet.add(rec.collateral_account_number);
    });
    const unassignedCollateralAccountsCount = unassignedCollateralAccountsSet.size;
    // assigned stats
    const { totalMarketValue: assignedTotalMarketValue, totalPostAllocationLendableValue: assignedAllocatedTotalLendableValue, effectiveAdvanceRate: assignedEffectiveAdvanceRate, } = (0, generateReceivableStats_1.generateReceivableStats)(assignedReceivables);
    const assignedCollateralAccountsSet = new Set();
    assignedReceivables.forEach((rec) => {
        assignedCollateralAccountsSet.add(rec.collateral_account_number);
    });
    const assignedCollateralAccountsCount = assignedCollateralAccountsSet.size;
    // loan stats
    const loanAccountsCount = loanBalances.size;
    const totalOutstandingBalance = lodash_1.default.sum(Array.from(loanBalances.values()));
    const totalMarginAvailability = (0, utils_1.calculateMarginAvailability)({
        collateralLendableValue: assignedAllocatedTotalLendableValue,
        loanOutstanding: totalOutstandingBalance,
    });
    const totalMarginAvailabilityRate = (0, utils_1.calculateMarginAvailabilityRate)({
        collateralLendableValue: assignedAllocatedTotalLendableValue,
        loanOutstanding: totalOutstandingBalance,
    });
    let underMarginStatusCount = 0;
    let nearMarginStatusCount = 0;
    let excessMarginStatusCount = 0;
    const groupByLoanAccount = (0, exports.groupReceivableResponseTape)({
        receivables: assignedReceivables,
        groupBy: 'loan_account_number',
    });
    // loanAccountNumbers without assignments will not appear in the above groupByLoanAccount
    // initialize the missing loan accounts without assignments
    Array.from(loanBalances.keys()).forEach((loanAccountNumber) => {
        if (!groupByLoanAccount[loanAccountNumber]) {
            groupByLoanAccount[loanAccountNumber] = [];
        }
    });
    Object.entries(groupByLoanAccount).forEach(([loanAccountNumber, groupedAssignedReceivables]) => {
        let loanAccountBalance = loanBalances.get(loanAccountNumber);
        if (typeof loanAccountBalance !== 'number') {
            warnings.push(`Warning: No outstanding balance existed for [loanAccountNumber:${loanAccountNumber}].  This most likely occurred because there a loan accounts with no stand-alone notes and no master commitment [including date filters]. Setting outstanding balance to 0.`);
            loanAccountBalance = 0;
        }
        const { totalMarketValue, effectiveAdvanceRate, preAllocationLendableValue, effectiveAllocationRate, totalPostAllocationLendableValue, } = getLoanAccountStats(groupedAssignedReceivables);
        const marginAvailability = (0, utils_1.calculateMarginAvailability)({
            collateralLendableValue: totalPostAllocationLendableValue,
            loanOutstanding: loanAccountBalance,
        });
        const marginAvailabilityRate = (0, utils_1.calculateMarginAvailabilityRate)({
            collateralLendableValue: totalPostAllocationLendableValue,
            loanOutstanding: loanAccountBalance,
        });
        const marginAvailabilityStatus = (0, utils_1.getMarginAvailabilityStatus)({
            loanOutstanding: loanAccountBalance,
            collateralLendableValue: totalPostAllocationLendableValue,
            marginAvailabilityRate,
        });
        if (marginAvailabilityStatus === 'underMargin') {
            underMarginStatusCount += 1;
        }
        else if (marginAvailabilityStatus === 'nearMargin') {
            nearMarginStatusCount += 1;
        }
        else {
            excessMarginStatusCount += 1;
        }
        loanAccountStats.push({
            loanAccountNumber,
            outstandingBalance: loanAccountBalance,
            assignedMarketValue: totalMarketValue,
            assignedPreAllocationLendableValue: preAllocationLendableValue,
            assignedPostAllocationLendableValue: totalPostAllocationLendableValue,
            marginAvailability,
            marginAvailabilityRate,
            effectiveAdvanceRate,
            effectiveAllocationRate,
            marginAvailabilityStatus,
            nearMarginThreshold: consts_1.NEAR_MARGIN_STATUS_THRESHOLD,
        });
    });
    return {
        portfolioStats: {
            // unassigned stats
            unassignedTotalMarketValue,
            unassignedTotalLendableValue: unassignedAllocatedTotalLendableValue,
            unassignedEffectiveAdvanceRate,
            unassignedCollateralAccountsCount,
            // assigned stats
            assignedTotalMarketValue,
            assignedTotalLendableValue: assignedAllocatedTotalLendableValue,
            assignedEffectiveAdvanceRate,
            assignedCollateralAccountsCount,
            totalOutstandingBalance,
            totalMarginAvailability,
            totalMarginAvailabilityRate,
            // counts
            // note: loanAccountsCount != underMarginStatusCount + nearMarginStatusCount + excessMarginStatusCount when there are assignment made to loan accounts without a valid master cmmt.
            // these exceptions will appear in the warning logs.
            loanAccountsCount,
            underMarginStatusCount,
            nearMarginStatusCount,
            excessMarginStatusCount,
            warnings,
        },
        collateralAccountStats,
        loanAccountStats,
    };
};
exports.getPortfolioReceivableResponseTapeStatsOnly = getPortfolioReceivableResponseTapeStatsOnly;
const generateEmptyPortfolioReceivableResponseTape = ({ reportingDate, asOfDate, creditAgreementId, metadata, }) => ({
    reportingDate,
    isPreview: utils.isValleyBankPreview(creditAgreementId),
    asOfDate,
    creditAgreementId,
    unassignedTotalMarketValue: null,
    unassignedTotalLendableValue: null,
    unassignedEffectiveAdvanceRate: null,
    unassignedCollateralAccountsCount: null,
    assignedTotalMarketValue: null,
    assignedTotalLendableValue: null,
    assignedEffectiveAdvanceRate: null,
    assignedCollateralAccountsCount: null,
    totalOutstandingBalance: null,
    totalMarginAvailability: null,
    totalMarginAvailabilityRate: null,
    loanAccountsCount: null,
    underMarginStatusCount: null,
    nearMarginStatusCount: null,
    excessMarginStatusCount: null,
    metadata,
    ingestionLogsS3Location: null,
    securitiesExtendedResponseTapeS3Location: null,
    depositsExtendedResponseTapeS3Location: null,
    loanAccountDetailsS3Location: null,
    collateralAssignmentsS3Location: null,
});
exports.generateEmptyPortfolioReceivableResponseTape = generateEmptyPortfolioReceivableResponseTape;
//# sourceMappingURL=receivableResponseTape.js.map